import { render, staticRenderFns } from "./FigureSignStatistics.vue?vue&type=template&id=0382d4ca&"
import script from "./FigureSignStatistics.vue?vue&type=script&lang=js&"
export * from "./FigureSignStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports